import { render, staticRenderFns } from "./LKMunMehFormDocuments.vue?vue&type=template&id=52ae02e8&"
import script from "./LKMunMehFormDocuments.vue?vue&type=script&lang=js&"
export * from "./LKMunMehFormDocuments.vue?vue&type=script&lang=js&"
import style0 from "./LKMunMehFormDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})
